// extracted by mini-css-extract-plugin
export var active = "_2n-7";
export var backButton = "_2n-6";
export var clone = "_2n-c";
export var collapseBar = "_2n-h";
export var collapseMode = "_2n-j";
export var dragHandle = "_2n-a";
export var dropdownIcon = "_2n-e";
export var hidden = "_2n-p";
export var iconContainer = "_2n-m";
export var iconSwapper = "_2n-o";
export var navItem = "_2n-4";
export var navItemIcon = "_2n-d";
export var navProfile = "_2n-5";
export var notificationCountBadge = "_2n-g";
export var notificationDot = "_2n-n";
export var optionsContainer = "_2n-f";
export var primaryNav = "_2n-0";
export var primaryTab = "_2n-k";
export var secondaryNav = "_2n-1";
export var selected = "_2n-l";
export var settingsNav = "_2n-2";
export var settingsNavItems = "_2n-3";
export var show = "_2n-b";
export var sideNav = "_2n-i";
export var teamItem = "_2n-8";
export var userProfileItem = "_2n-9";